// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"60e94293","453":"bc2ff9fe"}[chunkId] + ".chunk.js";
};